import { create } from "zustand";

export type ToastType = "success" | "error" | "warning" | "info";

export interface ToastItem {
  id: string;
  type: ToastType;
  title: string;
  message?: string;
  duration?: number;
  dismissible?: boolean;
  onClose?: () => void;
  action?: {
    label: string;
    onClick: () => void;
  };
}

interface ToastStore {
  toasts: readonly ToastItem[];
  showToast: (toast: Omit<ToastItem, "id">) => string;
  removeToast: (id: string) => void;
  clearAll: () => void;
}

/**
 * Store Zustand para el sistema de notificaciones global.
 *
 * Uso desde fuera de React:
 *   useToastStore.getState().showToast({ type: "error", title: "Error de red" })
 *
 * Uso desde componentes: usar el selector atómico `useToastStore(s => s.showToast)`.
 */
export const useToastStore = create<ToastStore>((set) => ({
  toasts: [],

  showToast: (toast) => {
    const id = crypto.randomUUID();

    set((state) => ({
      toasts: [...state.toasts, { ...toast, id }],
    }));

    return id;
  },

  removeToast: (id) =>
    set((state) => ({
      toasts: state.toasts.filter((t) => t.id !== id),
    })),

  clearAll: () => set({ toasts: [] }),
}));
